<template>
  <div id="sceances">
    <v-chip v-if="item['h10']" color="accent">10h</v-chip>
    <v-chip v-if="item['h14']" color="primary">14h</v-chip>
    <v-chip v-if="item['h18']" color="secondary">18h</v-chip>
    <v-chip v-if="item['h20']" color="secondary">20h</v-chip>
    <v-chip v-if="item['matin']" color="accent">Matin</v-chip>
    <v-chip v-if="item['apresmidi']" color="primary">Après-midi&nbsp;</v-chip>
  </div>
</template>

<script>
export default {
    props: {
        item: Object
    }
}
</script>